// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lGX4n","inner":"Footer_inner__T2tsQ","top":"Footer_top__xECN3","made":"Footer_made__QJUs5"};